import { useAppDispatch } from 'store/hooks';
import ticketListActions from '../actions';
import ticketListSelectors from '../selectors';
import { IApiSummaryPaymentTypeParam } from '../types/api';
import { useEffect } from 'react';
import dayjs from 'dayjs';

const useGetSummaryRevokedCash = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const summaryRevokedCash = ticketListSelectors.summaryRevokedCash();
  const params = ticketListSelectors.ticketsTableData.params();
  const mutate = (params: IApiSummaryPaymentTypeParam) => {
    dispatch(ticketListActions.getSummaryRevokedCash.fetch(params));
  };

  useEffect(() => {
    if (isLazy) return;
    mutate({
      startDate: params.startDate || dayjs().format('MM-DD-YYYY'),
      endDate: params.endDate || dayjs().format('MM-DD-YYYY'),
    });
  }, [params]);

  return {
    summaryRevokedCash,
    mutate,
  };
};

export default useGetSummaryRevokedCash;
